import React, {Component} from 'react';
import {Router, Route, Switch, Redirect} from 'react-router';

export default class Client extends Component {

  constructor(props){
    super(props);
    this.state = {};
  }

  render() {
    return (
      <h> Change Me! </h>
    )
  }
}
